import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Link from './Link';
import ShareButton from './ShareButton';
import TwitterIcon from '../Svg/TwitterIconFooter';

import { actionShared } from '../../containers/Widget/actions';
import { copyFor } from '../../copy/copy';

import staticData from '../../static_data/all';

if (typeof window !== 'undefined' && !staticData.useStatic) {
    window.twttr = (function(d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0],
            t = window.twttr || {};
        if (d.getElementById(id)) return t;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://platform.twitter.com/widgets.js';
        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];
        t.ready = function(f) {
            t._e.push(f);
        };

        return t;
    })(document, 'script', 'twitter-wjs');
}

const getTwitterShareUrl = (url, publisherName, partnerName) => {
    const text =
        partnerName !== undefined && partnerName !== 'Speakable'
            ? copyFor('sharing', 'twitterTextPartner', undefined, undefined, {
                  partnerName,
                  publisherName,
                  url
              })
            : copyFor('sharing', 'twitterTextNoPartner', undefined, undefined, {
                  publisherName,
                  url
              });
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
};

const TwitterShare = props => (
    <Link
        href={getTwitterShareUrl(props.shareUrl, props.publisherName, props.partnerName)}
        onClick={() => props.actionShared('twitter')}
    >
        <ShareButton>
            <TwitterIcon />
        </ShareButton>
    </Link>
);

TwitterShare.propTypes = {
    actionShared: PropTypes.func.isRequired,
    partnerName: PropTypes.string,
    publisherName: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired
};

export default connect(
    state => ({
        shareUrl: state.widget.articleUrl,
        publisherName:
            state.widget.twitterMention !== undefined
                ? '@' + state.widget.twitterMention
                : state.widget.publisherName || 'Speakable',
        partnerName:
            state.widget.selectedPartner !== undefined
                ? state.widget.selectedPartner.twitterMention !== undefined
                    ? '@' + state.widget.selectedPartner.twitterMention
                    : state.widget.selectedPartner.name
                : undefined
    }),
    {
        actionShared
    }
)(TwitterShare);



// WEBPACK FOOTER //
// ./src/components/SocialShareFooter/TwitterShare.jsx